import React from 'react';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const SensorListTableHead = () => {
  const { t } = useTranslation();
  return (
    <div className={style.sensorListTableHead}>
      <div className={style.sensorListTableDescription}>{t('Sensor description')}</div>
      <div className={style.sensorListTableCode}>{t('Sensor hex code')}</div>
      <div className={style.sensorListTableStatus}>{t('Status')}</div>
      <div className={style.sensorListTableType}>{t('Type')}</div>
    </div>
  );
};

export default SensorListTableHead;
